import { useEffect, useMemo, useState, useContext } from 'react';
import { useLocation } from 'react-use';

import RouterLink from '@/react_app/common/RouterLink';
import { AppMenu, MenuProps, AppTypography } from '@/react_app/components/Atoms/index';
// import HeaderTop from '@/react_app/components/BillingUsage/Global/Header/HeaderTop';
import { PaymentMethodContext } from '@/react_app/components/BillingUsage/contexts';
import {
	BILLING_USAGE_HISTORY_ROUTE_NAME,
	BILLING_USAGE_OVERVIEW_ROUTE_NAME,
	BILLING_USAGE_SETTINGS_ROUTE_NAME,
	BILLING_USAGE_PAYMENT_METHODS_ROUTE_NAME,
	BILLING_USAGE_INVOICE_HISTORY_ROUTE_NAME,
} from '@/router/BillingUsage/billing-usage-router.const';
type HeaderNavigationItem = {
	label: string;
	href: string;
};

interface HeaderProps {
	title?: string;
	navigation?: HeaderNavigationItem[];
}

const paidPlanRequiredItems: MenuProps['items'] = [
	{
		key: 'settings',
		label: (
			<RouterLink class="no-underline" to={{ name: BILLING_USAGE_SETTINGS_ROUTE_NAME }}>
				Settings
			</RouterLink>
		),
	},

	{
		key: 'invoice-history',
		label: (
			<RouterLink class="no-underline" to={{ name: BILLING_USAGE_INVOICE_HISTORY_ROUTE_NAME }}>
				Invoice history
			</RouterLink>
		),
	},
];
const alwaysShownItems: MenuProps['items'] = [
	{
		key: 'overview',
		label: (
			<RouterLink class="no-underline" to={{ name: BILLING_USAGE_OVERVIEW_ROUTE_NAME }}>
				Overview
			</RouterLink>
		),
	},
	{
		key: 'usage-history',
		label: (
			<RouterLink class="no-underline" to={{ name: BILLING_USAGE_HISTORY_ROUTE_NAME }}>
				Usage history
			</RouterLink>
		),
	},
	{
		key: 'payment-methods',
		label: (
			<RouterLink class="no-underline" to={{ name: BILLING_USAGE_PAYMENT_METHODS_ROUTE_NAME }}>
				Payment methods
			</RouterLink>
		),
	},
];

const Header = ({ title }: HeaderProps) => {
	const paymentMethodContextValue = useContext(PaymentMethodContext);
	if (paymentMethodContextValue === null) {
		return null;
	}
	const { paymentMethods } = useMemo(() => paymentMethodContextValue, [paymentMethodContextValue]);
	const [current, setCurrent] = useState('overview');
	const hasPaymentMethod = useMemo(() => paymentMethods.length > 0, [paymentMethods]);

	const items = useMemo(() => {
		if (hasPaymentMethod) {
			return [...alwaysShownItems, ...paidPlanRequiredItems];
		} else {
			return alwaysShownItems;
		}
	}, [alwaysShownItems, paidPlanRequiredItems, hasPaymentMethod]);

	const location = useLocation();

	useEffect(() => {
		const pathName = location.pathname;
		const pathNameParts = pathName?.split('/');
		setCurrent(pathNameParts?.[4] || 'overview');
	}, [location, useLocation]);
	return (
		<header className="border-b border-[#DFE3EA] relative">
			{/* <HeaderTop /> */}
			<div className="pt-8 pl-7">
				<AppTypography.Title level={3}>{title}</AppTypography.Title>
				<AppMenu mode="horizontal" items={items} selectedKeys={[current]} className="mb-[10px] border-b-0" />
			</div>
		</header>
	);
};

export default Header;
